import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function useRevealOnScroll() {
  const { pathname } = useLocation();

  useEffect(() => {
    const revealElements = document.querySelectorAll('.reveal');

    if (!('IntersectionObserver' in window)) {
      revealElements.forEach((element) => element.classList.add('reveal--visible'));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -60px 0px' },
    );

    revealElements.forEach((element) => {
      element.classList.remove('reveal--visible');
      observer.observe(element);
    });

    return () => observer.disconnect();
  }, [pathname]);
}

export default useRevealOnScroll;
